/** Her lease, /lease/<token> (MTR #578). In its own file so the server and the browser read one shape. */
export const leaseTokenFromPath = (path) => {
  const m = /^\/lease\/([A-Za-z0-9_-]{43})\/?$/.exec(String(path ?? ''))
  return m ? m[1] : null
}
